<template>
  <div :class="{MusicKnowledgeWrapper: !innnerContent, 'stb-style': deviceType === 'stb'}">
    <img v-if="showStbClose" src="../../assets/images/play-dialog-close.png" class="stb-close" @click="handleStbClose">
    <div class="innerContent" v-if="innnerContent">
      <slot></slot>
    </div>
    <template v-else>
      <img src="../../assets/images/bg.png" class="bg"/>
      <div class="content">
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MusicKnowledgeWrapper',
  props: {
    innnerContent: {
      type: Boolean,
      default: false
    },
    showStbClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['deviceType'])
  },
  methods: {
    // 机顶盒关闭
    handleStbClose () {
      try {
        window.jsInterface.jsCallAndroid2Finish()
      } catch {
        this.$alert('触发 Bridge 失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.innerContent {
  width: 100%;
  height: 100%;
  background: #feefb6;
  overflow: hidden;
  border-radius: 16px;
}
.MusicKnowledgeWrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e17e1a;
  overflow: hidden;
  min-height: 720px; /* 防止输入法将内容可视区域压缩 */
  .bg {
    display: block;
    position: absolute;
    width: 100%;
    user-select:none;
    pointer-events: none;
  }
  .content {
    position: absolute;
    width: 1246px;
    height: 684px;
    background: #feefb6;
    border-radius: 16px;
    z-index: 2;
    box-shadow: 0 0 12px rgba(170, 106, 40, 0.2);
    top: 50%;
    left: 50%;
    margin-left: -623px;
    margin-top: -342px;
  }
}
.stb-close {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
}
/* 适配宽屏 */
@media screen and (width: 1920px) {
  .MusicKnowledgeWrapper.stb-style {
    .content {
      width: 1870px;
      height: 1026px;
      border-radius: 24px;
      margin-left: -935px;
      margin-top: -513px;
    }
    .stb-close {
      width: 92px;
      position: fixed;
      top: 0;
      right: 0;
      z-index: 100;
    }
  }
}
</style>
